const fm = new Intl.NumberFormat("es-MX", {
	minimumFractionDigits: 2,
	maximumFractionDigits: 2,
  });

const fmQty = new Intl.NumberFormat("es-MX", {
  minimumFractionDigits: 1,
  maximumFractionDigits: 2,
});
const Columns = ({filters}) => {
		let columns = [
			{
				id: 'unit',
				name: 'Unidad',
        minWidth:'100px',
        selector: row => row.number,
      },
      {
				id: 'periodo',
				name: 'Periodo',
        minWidth:'200px',
        selector: row => `${filters.initDate} al ${filters.endDate}`,
      },
      {
				id: 'salidas_count',
				name: 'Salidas',
        minWidth:'100px',
        selector: row => row.salidas_count,
      },
      {
				id: 'litros',
				name: 'Litros',
        minWidth:'120px',
        selector: row => fmQty.format(row.quantity ?? 0),
        center: true
      },
      {
				id: 'cost',
				name: 'Costo',
        minWidth:'120px',
        selector: row => fm.format(row.cost ?? 0),
        center: true
      }
		];
	return columns;
}

export default Columns;

//vaneton beicli